export default "<div id=\"columns_chart_div\"></div>\r\n\r\n";